export default __webpack_public_path__ + "static/media/regenerate.76fc7185.svg";